import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
//import { createDevice } from "../services/createDevice";
import Box from "@mui/material/Box";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import Select from "react-select";

import { environment } from "../../../environment";
// import Dropdown from "./Dropdown";
//import CustomListDropDown from "../Components/CustomListDropDown";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import Multiselect from "multiselect-react-dropdown";
import { Redirect } from "react-router-dom";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";
// import { useEffect } from "react";
import Container, { TableContainer, TextField } from "@mui/material";
import Device from "../Device";
import NavbarNew from "../../Components/NavbarNew";
//import { console } from 'console';

const MySwal = withReactContent(Swal);

const AddDevicePartner = ({ history, match }) => {
  const [dap_deviceList, setDapDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [dap_category, setCategory] = useState([]);
  const [natureOfDamage, setnature] = useState([]);
  const [device_access_token, setAccessToken] = useState("");
  const [device_label, setLabel] = useState("");
  const [device_version, setVersion] = useState("");
  const [box_categories, setboxcategories] = useState([]);
  const [DeviceNo, setDeviceNo] = useState("");

  const [display_suggestion, setDisplaySuggestion] = useState([
    {
      display: "none",
      zIndex: "-999",
    },
  ]);
  const [product_categories, setproductcategories] = useState([]);
  const [product_suggestion, setProductSuggestion] = useState([
    {
      display: "none",
      zIndex: "-999",
    },
  ]);
  const [duplicate, setDuplicate] = useState(false);
  const [assigned, setAssigned] = useState(false);
  const [ExistDevices, setExistDevices] = useState(false);

  // const [box_type,setBoxType] = useState()
  const [displayBoxType, setDisplayBoxType] = useState([
    {
      display: "none",
    },
  ]);

  const [inputfields, setInputFields] = useState([
    {
      deviceName: "",
      deviceLabel: "",
      deviceVersion: "",
      deviceCategory: "",
      AccessToken: "",
      deviceType: "",
      deviceTypeId: "",
      boxType: "",
      natureOfDamage: "",
      isbox: false,
      // isInstalled: false,
      // shipmentIdMongo: "",
    },
  ]);

  useEffect(() => {
    const dispProductSuggestion = [...product_suggestion];
    dispProductSuggestion[0] = { display: "none", zIndex: "-999" };
    setDisplaySuggestion(dispProductSuggestion);

    const dispSuggestion = [...display_suggestion];
    dispSuggestion[0] = { display: "none", zIndex: "-999" };
    setDisplaySuggestion(dispSuggestion);

    const dispBoxType = [...displayBoxType];
    dispBoxType[0] = { display: "none" };
    setDisplayBoxType(dispBoxType);

    getBoxCategory();
    getProductCategory();
  }, []);

  const getBoxCategory = () => {
    axios
      .get(environment.dap_url + "boxApi/getAllBoxCategory")
      .then((res) => {
        setboxcategories(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getProductCategory = () => {
    axios
      .get(environment.dap_url + "productCategory/getAll")
      .then((res) => {
        setproductcategories(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const displaySuggestion = (index) => {
    // console.log(index)
    const dispSuggestion = [...display_suggestion];
    dispSuggestion[index] = { display: "block", zIndex: "999" };
    setDisplaySuggestion(dispSuggestion);

    // setDisplaySuggestion("block")
  };
  const displayProductSuggestion = (index) => {
    // console.log(index)
    const productSuggestion = [...product_suggestion];
    productSuggestion[index] = { display: "block", zIndex: "999" };
    setProductSuggestion(productSuggestion);

    // setDisplaySuggestion("block")
  };

  const hideProductSuggestion = (index) => {
    const productSuggestion = [...product_suggestion];
    productSuggestion[index] = { display: "none", zIndex: "0" };
    setProductSuggestion(productSuggestion);
  };

  const searchBox = (value) => {
    setboxcategories([]);
    let arr = [];
    // getBoxCategory();
    box_categories.filter((category) => {
      // category.includes(value)
      console.log(category.boxCategoryName);
      if (category.boxCategoryName.includes(value)) {
        arr.push(category);
        setboxcategories(arr);
      }
      console.log(arr);
    });
    // console.log(filtered);
  };

  const setDeviceTypeInput = (index, val) => {
    // setDisplaySuggestion("none");
    const dispSuggestion = [...display_suggestion];
    dispSuggestion[index] = { display: "none", zIndex: "-999" };
    setDisplaySuggestion(dispSuggestion);

    const values = [...inputfields];
    values[index]["boxType"] = val;
    console.log(values);
  };

  const setDeviceTypeInputProduct = (index, val, event) => {
    // setDisplaySuggestion("none");
    const dispSuggestion = [...product_suggestion];
    dispSuggestion[index] = { display: "none", zIndex: "-999" };
    setProductSuggestion(dispSuggestion);

    const values = [...inputfields];
    values[index]["deviceType"] = val;

    if (event.target.name == "deviceType") {
      event.target.value = "DAP BOX";
    }

    console.log(values);
    console.log(values.length);
    setDeviceNo(values.length);
  };

  const handleChangeInput = (index, event) => {
    event.persist();
    //console.log(event);
    console.log(event.target.value);
    const myarray = event.target.value.split("|");
    const values = [...inputfields];
    // console.log("myarray", myarray);
    values[index][event.target.name] = event.target.value;
    setInputFields(values);

    if (event.target.name === "deviceLabel") {
      const deviceLabel = event.target.value;
      let userDetails = localStorage.getItem("user");
      userDetails = JSON.parse(userDetails);
      console.log(deviceLabel);

      // Check for duplicate device label
      axios
        .post(environment.dap_url + "dapDevice/checkPresentIninventory", {
          userid: userDetails._id,
          deviceLabel: deviceLabel,
        })
        .then((resp) => {
          console.log(resp);
          if (resp.data.status === true) {
            setDuplicate(true);
            setAssigned(false);
            setExistDevices(false);
          } else {
            axios
              .post(environment.dap_url + "dapDevice/isassignedToCustomer", {
                deviceLabel: deviceLabel,
              })
              .then((resp) => {
                console.log(resp);
                if (resp.data.status === true) {
                  setAssigned(true);
                  setExistDevices(false);
                } else {
                  setAssigned(false);
                  let userDetails = localStorage.getItem("user");
                  userDetails = JSON.parse(userDetails);
                  console.log(userDetails._id);
                  axios
                    .get(
                      environment.dap_url +
                        `dapDevice/damagedDevices/` +
                        userDetails._id
                    )
                    .then((resp) => {
                      console.log(resp);
                      // console.log(resp.data[0].deviceLabel);
                      console.log(resp.data.length);

                      // array.every((element) => element === value)
                      resp.data.every((value) => {
                        if (value.deviceLabel === deviceLabel) {
                          setExistDevices(true);
                          console.log("Device Exists");
                          return false;
                        } else {
                          setExistDevices(false);
                          console.log("Device does not Exist");
                          return true;
                        }
                      });
                    });
                }
              });
            setDuplicate(false);
          }
        });

      // Check if device is already assigned to a customer
    }

    if (event.target.name == "deviceType") {
      if (event.target.value == "DAP BOX") {
        const dispBoxType = [...displayBoxType];
        dispBoxType[index] = { display: "block" };
        setDisplayBoxType(dispBoxType);
        const dispProductSuggestion = [...product_suggestion];
        dispProductSuggestion[index] = { display: "none", zIndex: "-999" };
        setProductSuggestion(dispProductSuggestion);
        values[index]["isbox"] = true;
      } else {
        const dispProductSuggestion = [...product_suggestion];
        dispProductSuggestion[index] = { display: "block", zIndex: "999" };
        setProductSuggestion(dispProductSuggestion);

        document.getElementById("myCheck" + index).checked = false;
        const dispBoxType = [...displayBoxType];
        values[index]["isbox"] = false;
        // document.getElementById(index+"boxType").value = '';

        dispBoxType[index] = { display: "none" };
        setDisplayBoxType(dispBoxType);
      }
    }
    // if (event.target.deviceLabel != "") {
    //   console.log(inputfields[0].deviceLabel);
    //   // let userDetails = localStorage.getItem("userDetails");
    //   // userDetails = JSON.parse(userDetails);
    //   // console.log("hiii");
    //   axios
    //     .post(environment.dap_url + "dapDevice/checkDuplicate", {
    //       deviceLabel: inputfields[0].deviceLabel,
    //     })
    //     .then((resp) => {
    //       console.log(resp);
    //       if (resp.data.status == true) {
    //         setDuplicate(true);
    //       } else {
    //         setDuplicate(false);
    //       }
    //     });
    // }
    console.log("---------");
    // console.log(inputfields);
    if (myarray.length == 5) {
      scanqr(index, event, myarray);
    }
    // scanqr(index, event);

    console.log(values);
    if (myarray.length == 5) {
      if (values[index]["deviceLabel"]) {
        let userDetails = localStorage.getItem("userDetails");
        userDetails = JSON.parse(userDetails);
        console.log(values[index]["deviceLabel"]);
        axios
          .get(
            environment.dap_url +
              "CheckDuplicateDevice/" +
              userDetails.data.tenantId.id
          )
          .then((resp) => {
            console.log(resp);
            if (resp.data.status == true) {
              setDuplicate(true);
            } else {
              setDuplicate(false);
            }
          });
      }
      // }else{
    }
    values[index][event.target.name] = event.target.value;
    setInputFields([...inputfields, values]);
    onScan(index, event);
  };
  const onScan = (index, event) => {
    event.persist();
    if (event.target.value == "DAP BOX" && event.target.name == "deviceType") {
      document.getElementById("myCheck" + index).checked = true;
      const dispBoxType = [...displayBoxType];
      dispBoxType[index] = { display: "block" };
      setDisplayBoxType(dispBoxType);
    } else {
      if (event.target.name == "boxType") {
        // setDeviceTypeInput(index,event.target.value)
        if (event.target.values == "") {
          getBoxCategory();
          console.log("");
        }
        searchBox(event.target.value);
      } else {
        const dispSuggestion = [...display_suggestion];
        dispSuggestion[index] = { display: "none", zIndex: "-999" };
        setDisplaySuggestion(dispSuggestion);
      }
    }
    // console.log(index, event.target.name);
    let qrvalue = event.target.value;
    let qrCodeArray = qrvalue.split("|");
    const values = [...inputfields];
    values[index][event.target.value] = qrCodeArray[0];
    // console.log(values);
    setInputFields(values);
    // setInputFields([
    //   ...inputfields,
    //   {
    //     deviceType: qrCodeArray[1],
    //     deviceLabel:  qrCodeArray[0],
    //     accessToken:  qrCodeArray[2],
    //     deviceVersion:  qrCodeArray[3],
    //     isInstalled: false,
    //   },
    // ]);
    // values[index][event.target.name] = event.target.value;
  };

  const scanqr = async (index, event, myarray) => {
    console.log("QRcodevalue", event.target.value);

    // await axios.post(environment.dap_url+"dapDevice/checkDuplicate",{deviceLabel:myarray[1]}).then(resp=>{
    //   console.log(resp);
    //   if(resp.data.status == true){
    const values = [...inputfields];
    values[index]["deviceLabel"] = myarray[1];
    values[index]["deviceVersion"] = myarray[2];
    values[index]["AccessToken"] = myarray[3];
    // values[index]["deviceType"] = myarray[0];
    var el = document.getElementById(index + "deviceType");
    el.value = myarray[0];
    // setInputFields(...inputfields,values)
    //   }else{
    //     MySwal.fire({
    //       title:"Can't add this asset",
    //       text:"This asset is already present in the inventory",
    //       icon:"error"
    //     })
    //     const values = [...inputfields];
    //     values[index]["deviceLabel"] = "";
    //     values[index]["deviceVersion"] = "";
    //     values[index]["AccessToken"] = "";
    //     values[index]["deviceType"] = "";
    //     var el = document.getElementById(index + "deviceType");
    //     el.value = "";
    //   }
    // })

    // values[index]["deviceLabel"] = myarray[1];
    // values[index]["deviceLabel"] = myarray[1];

    // const values = [...inputfields];
    // value[index]['deviceLabel']
  };

  const formValidation = (inputfields) => {
    console.log(inputfields);
  };

  const submitHandler = (e) => {
    console.log(inputfields);
    formValidation(inputfields);
    setLoading(true);
    e.preventDefault();
    let isValid = true;

    inputfields.forEach((value) => {
      if (value.deviceLabel === "") {
        setLoading(false);
        MySwal.fire({
          title: <p>Please enter the device label!</p>,
        });
        isValid = false;
      } else if (value.natureOfDamage === "") {
        setLoading(false);
        MySwal.fire({
          title: <p>Please enter the nature of damage!</p>,
        });
        isValid = false;
      }
    });

    if (isValid) {
      setLoading(false);
      MySwal.fire({
        title: <p>Device has been successfully added!</p>,
      });
      axios
        .put(
          environment.dap_url + "inventoryApi/addDamagedDevices",
          inputfields
        )
        .then((res) => {
          // MySwal.fire({
          //   title: <p>Device has been successfully added!</p>,
          //   type: "success",
          // });
          setLabel("");
          setVersion("");
          setAccessToken("");
          setCategory("");
          setnature("");
          history.push("/partner-damaged-devices");
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          MySwal.fire({
            title: (
              <p>{err?.response?.data?.message || "Device creation failed"}</p>
            ),
            type: "error",
          });
        });
    }
  };

  // inputfields.forEach((value) => {
  //   if (value.natureOfDamage != "") {
  //     console.log("Yes");
  //     setLoading(true); // Move setLoading(true) here
  //     axios
  //       .put(
  //         environment.dap_url + "inventoryApi/addDamagedDevices",
  //         inputfields
  //       )
  //       .then((res) => {
  //         MySwal.fire({
  //           title: <p>Device has been successfully Added!</p>,
  //           type: "success",
  //         });
  //         setLabel("");
  //         setVersion("");
  //         setAccessToken("");
  //         setCategory("");
  //         setnature("");
  //         history.push("/partner-damaged-devices");
  //         setLoading(false); // Move setLoading(false) inside the then block
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //         MySwal.fire({
  //           title: (
  //             <p>
  //               {err?.response?.data?.message || "Device creation failed"}
  //             </p>
  //           ),
  //           type: "error",
  //         });
  //       });
  //   } else {
  //     setLoading(false);
  //     console.log("No");
  //     MySwal.fire({
  //       title: <p>Please enter The nature Of Damage</p>,
  //       type: "error",
  //     });
  //     return true;
  //   }
  // });

  const handleAddClick = (e) => {
    e.preventDefault();
    // console.log(e.preventDefault);
    setInputFields([
      ...inputfields,
      {
        deviceName: "",
        deviceLabel: "",
        deviceVersion: "",
        deviceCategory: "",
        AccessToken: "",
        deviceType: "",
        natureOfDamage: "",
        deviceTypeId: "",
        boxType: "",
      },
    ]);
    setDisplayBoxType([...displayBoxType, { display: "none" }]);
    setDisplaySuggestion([
      ...display_suggestion,
      { display: "none", zIndex: "-999" },
    ]);
    setProductSuggestion([
      ...display_suggestion,
      { display: "none", zIndex: "-999" },
    ]);
    console.log("hello");
    // console.log(setInputFields);
    console.log(inputfields);
  };

  const handleRemoveClick = (index, e) => {
    e.preventDefault();
    const dispSuggestion = [...display_suggestion];
    dispSuggestion.splice(index, 1);
    setDisplaySuggestion(dispSuggestion);

    const dispProductSuggestion = [...product_suggestion];
    dispProductSuggestion.splice(index, 1);
    setProductSuggestion(dispProductSuggestion);

    const dispBoxType = [...displayBoxType];
    dispBoxType.splice(index, 1);
    setDisplayBoxType(dispBoxType);

    const values = [...inputfields];
    values.splice(index, 1);
    setInputFields(values);
  };
  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <div className="container-fluid">
          <Link to="/partner-damaged-devices" className="btn btn-light my-3">
            Go Back
          </Link>
        </div>
      </div>

      <div className="container">
        <h1 className="text-center">Add Asset</h1>
        <div>
          <Form>
            {/* <Form.Group controlId="name">
                    <Form.Label>* Consignee</Form.Label>
                    <CustomListDropDown />
                  </Form.Group>
                  <div className="row">
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>Country</Form.Label>
                        <Select
                          options={countries.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectCountry(e)}
                          // defaultValue={dap_deviceList[0].name}
                          defaultValue="hi there"
                          placeholder="Country"
                        />
                      </Form.Group>
                    </div>
                  </div> */}

            <TableContainer>
              {inputfields.map((inputField, index) => (
                <div key={index}>
                  <div style={{ display: "inline-flex" }}>
                    <div className="box">
                      <TextField
                        name="deviceType"
                        label="Asset Category"
                        autoComplete="off"
                        // variant="filled"
                        style={{
                          margin: 5,
                        }}
                        id={index + "deviceType"}
                        value={inputField.deviceType}
                        onChange={(event) => handleChangeInput(index, event)}
                        onFocus={(event) => displayProductSuggestion(index)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            hideProductSuggestion(index);
                          }
                        }}
                        // onBlur={() => {
                        //   setTimeout(() => {
                        //     hideProductSuggestion(index);
                        //   }, 100);
                        // }}
                        // onBlur={(e)=>setDisplaySuggestion("none")}
                      />
                      <div
                        style={{
                          height: "auto",
                          width: "220px",
                          position: "absolute",
                          backgroundColor: "white",
                          borderRadius: "5px",
                          border: "1px solid #d9d9d9",
                          display: product_suggestion[index].display,
                          zIndex: product_suggestion[index].zIndex,
                        }}
                      >
                        <ul style={{ listStyle: "none" }}>
                          {product_categories?.map((val, key) => {
                            return (
                              <li
                                style={{
                                  padding: "5px",
                                  margin: "2px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  setDeviceTypeInputProduct(
                                    index,
                                    val.productCategoryName,
                                    e
                                  );
                                }}
                              >
                                {val.productCategoryName}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                    {/* <Select
                            options={countries.map((element) => ({
                              id: element.isoCode,
                              value: element.name,
                              label: element.name,
                            }))}
                            onChange={(e) => selectCategory(e)}
                            // defaultValue={dap_deviceList[0].name}
                            // defaultValue="hi there"
                            placeholder="Device Category"
                            style={{
                              margin: 5,
                            }}
                          /> */}
                    <TextField
                      name="deviceLabel"
                      label="Asset Label"
                      autoComplete="off"
                      style={{
                        margin: 5,
                      }}
                      value={inputField.deviceLabel}
                      onChange={(event) => handleChangeInput(index, event)}
                    />

                    <TextField
                      name="deviceVersion"
                      label="Asset Version"
                      autoComplete="off"
                      // variant="filled"git b
                      style={{
                        margin: 5,
                      }}
                      value={inputField.deviceVersion}
                      onChange={(event) => handleChangeInput(index, event)}
                    />
                    <TextField
                      name="AccessToken"
                      label="Access Token"
                      autoComplete="off"
                      // variant="filled"
                      style={{
                        margin: 5,
                      }}
                      value={inputField.AccessToken}
                      onChange={(event) => handleChangeInput(index, event)}
                    />

                    <TextField
                      name="natureOfDamage"
                      label="Nature of Damage"
                      autoComplete="off"
                      style={{ margin: 5 }}
                      value={inputField.Nature}
                      onChange={(event) => handleChangeInput(index, event)}
                      inputProps={{
                        pattern: "[a-zA-Z0-9 ]+",
                        maxLength: 50,
                      }}
                    />
                    <div className="box" style={{ width: "auto" }}>
                      <TextField
                        name="boxType"
                        label="Box Category"
                        // variant="filled"
                        style={{
                          margin: 5,
                          display: displayBoxType[index].display,
                        }}
                        id={index + "boxType"}
                        value={inputField.boxType}
                        onChange={(event) => handleChangeInput(index, event)}
                        onFocus={(e) => displaySuggestion(index)}
                        // onBlur={(e)=>setDisplaySuggestion("none")}
                      />
                      <div
                        style={{
                          height: "auto",
                          width: "220px",
                          position: "absolute",
                          backgroundColor: "white",
                          borderRadius: "5px",
                          border: "1px solid #d9d9d9",
                          display: display_suggestion[index].display,
                          zIndex: display_suggestion[index].zIndex,
                        }}
                      >
                        <ul style={{ listStyle: "none" }}>
                          {box_categories?.map((val, key) => {
                            return (
                              <li
                                style={{
                                  padding: "5px",
                                  margin: "2px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  setDeviceTypeInput(
                                    index,
                                    val.boxCategoryName
                                  );
                                }}
                              >
                                {val.boxCategoryName}
                              </li>
                            );
                          })}
                        </ul>
                      </div>{" "}
                      {/* <label style={{ fontSize: "20px" }}>
                              Is box?
                              <input
                                type="checkbox"
                                id={"myCheck" + index}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginLeft: "10px",
                                  marginTop: "10px",
                                }}
                              />
                            </label> */}
                    </div>
                  </div>

                  <div>
                    {duplicate && index === DeviceNo - 1 ? (
                      <p style={{ marginLeft: "5px", color: "red" }}>
                        Device does not exist
                      </p>
                    ) : (
                      ""
                    )}
                    {assigned && index === DeviceNo - 1 ? (
                      <p style={{ marginLeft: "5px", color: "red" }}>
                        Device already assigned to customer
                      </p>
                    ) : (
                      ""
                    )}
                    {ExistDevices && index === DeviceNo - 1 ? (
                      <p style={{ marginLeft: "5px", color: "red" }}>
                        Device already added in damaged devices
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {index === 0 ? (
                      <button
                        style={{
                          display: "none",
                        }}
                      >
                        Delete
                      </button>
                    ) : (
                      <button
                        className="btn btn-danger btn-sm"
                        style={{
                          margin: 17,
                        }}
                        onClick={(e) => handleRemoveClick(index, e)}
                      >
                        Delete
                      </button>
                    )}

                    {index === DeviceNo - 1 ? (
                      <button
                        className="btn btn-primary btn-sm"
                        style={{
                          margin: 17,
                        }}
                        disabled={
                          loading || duplicate || assigned || ExistDevices
                        }
                        onClick={(e) => handleAddClick(e)}
                      >
                        AddMore
                        {/* <svg
                            // xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="currentColor"
                            class="bi bi-plus-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                          </svg> */}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary btn-sm"
                        style={{
                          margin: 17,
                        }}
                        // disabled={
                        //   loading || duplicate || assigned || ExistDevices
                        // }
                        onClick={(e) => handleAddClick(e)}
                      >
                        AddMore
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </TableContainer>

            <div className="col-md-6">
              <Button
                type="button"
                className="btn btn-block  btn-primary btn-lg font-weight-medium auth-form-btn"
                disabled={loading || duplicate || assigned || ExistDevices}
                style={{ marginLeft: 221 }}
                onClick={submitHandler}
              >
                Add Asset
                {loading && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{
                      marginRight: "10px",
                    }}
                  />
                )}
                {loading && <span></span>}
                {!loading && <span></span>}
              </Button>
            </div>
          </Form>
        </div>
        <div className="col-lg-3"></div>
      </div>
    </>
  );
};

export default AddDevicePartner;
